import { MinzeElement, Attrs } from 'minze'
import { formatEventDateTime, formatStartTime } from '../../../modules/date'
import MainModule from '../../../modules/main'

export interface LvcDate {
  startDate: string
  endDate: string
  includeStartTime: boolean
}

export class LvcDate extends MinzeElement {
  attrs: Attrs = ['start-date', 'end-date', ['include-start-time', false]]

  html = () => {
    const startDate = this.startDate as string
    const endDate = this.endDate as string
    const lang = MainModule.getInstance().getLocale().getLanguage()

    if (!startDate) {
      return ''
    }
    const formattedEventDateTime = formatEventDateTime(
      lang,
      {
        includeStartTime: this.includeStartTime || false,
      },
      startDate,
      endDate
    )
    const formattedStartTime = formatStartTime(lang, startDate, endDate)

    return [formattedEventDateTime || '', formattedStartTime || ''].join(' ')
  }
}
